import styled, { css } from 'styled-components';

export const TopRow = styled.div`
  display: flex;
  align-items: stretch;
  gap: ${({ theme }) => theme.spacing(1.5)};

  ${({ theme }) =>
    theme.isMobile &&
    css`
      flex-direction: column;
    `};

  @container goal-detail-content (max-width: 928px) {
    flex-direction: column;
  }
`;

export const Column = styled.div`
  flex: 1 1 0;
  min-width: 0;
  display: flex;
  flex-direction: column;

  & > * {
    flex: 1;
  }

  ${({ theme }) =>
    theme.isMobile &&
    css`
      flex: 0 0 auto;
    `};

  @container goal-detail-content (max-width: 928px) {
    flex: 0 0 auto;
  }
`;
